// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
      CLOSE: 'Close',
    },
    SEO: {
      SITE_NAME: 'BimParts - Industrial Parts & Equipment',
      HOMEPAGE_TITLE: 'BimParts - Leading Industrial Parts & Equipment Supplier in Vietnam',
      HOMEPAGE_DESCRIPTION:
        "BIM BIM JOINT STOCK COMPANY - Vietnam's premier supplier of industrial parts, forklift parts, and heavy equipment components. Quality guaranteed, competitive prices.",
      HOMEPAGE_KEYWORDS:
        'industrial parts, forklift parts, equipment parts, Vietnam supplier, BimParts, heavy equipment',
      PRODUCT_TITLE_TEMPLATE: '{productName} | BimParts Industrial Parts',
      PRODUCT_DESCRIPTION_TEMPLATE:
        '{productName} from {brandName} - High quality industrial parts at competitive prices. Available at BimParts Vietnam.',
      CATEGORY_TITLE_TEMPLATE: '{categoryName} | Industrial Parts | BimParts',
      CATEGORY_DESCRIPTION_TEMPLATE:
        'Browse {categoryName} industrial parts and equipment. Quality products with warranty at BimParts Vietnam.',
      ABOUT_TITLE: 'About BimParts - Industrial Parts Specialist',
      ABOUT_DESCRIPTION:
        "Learn about BIM BIM JOINT STOCK COMPANY, Vietnam's trusted supplier of industrial parts and equipment since establishment.",
      CONTACT_TITLE: 'Contact BimParts - Industrial Parts Supplier',
      CONTACT_DESCRIPTION:
        'Get in touch with BimParts for industrial parts inquiries. Professional support and nationwide delivery in Vietnam.',
    },
    MENU: {
      HOME: 'Home',
      CATEGORIES: 'Categories',
      NEW: 'New',
      DOWNLOAD: 'Download',
      CERTIFICATE: 'Certificate',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      ALL_CATEGORIES: 'All Categories',
      VIDEO_CHANNEL: 'Video channel',
      ABOUT_US: 'About us',
      CONTACT: 'Contact',
      TOP_RANKING_PRODUCTS: 'Top-ranking Products',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      DELIVER_TO: 'Deliver to',
      LOCATION: {
        DELIVER_TO: 'Deliver to',
        SPECIFY_LOCATION: 'Specify your location',
        SHIPPING_NOTICE: 'Shipping options and fees vary based on your location',
        ADD_ADDRESS: 'Add address',
        OR: 'Or',
        SELECT_COUNTRY: 'Select country',
        SAVE: 'Save',
      },
      LANGUAGE: {
        SET_LANGUAGE_CURRENCY: 'Set language and currency',
        DESCRIPTION: 'Select your preferred language and currency.',
        DESCRIPTION2: 'You can update the setting at any time.',
        LANGUAGE: 'Language',
        CURRENCY: 'Currency',
        SAVE: 'Save',
      },
      PROFILE: {
        EDIT_INFO: 'Edit Profile',
        ADMIN_PAGE: 'Admin page',
        MY_CART: 'My cart',
        MY_ORDERS: 'My Orders',
        MY_INQUIRIES: 'My Inquiries',
        MY_EQUIPMENT: 'My Equipment',
        MY_EQUIPMENT_STATISTICS: 'My Equipment Statistics',
        EQUIPMENT_INFO: 'Equipment Info',
        EQUIPMENT_LIST: 'Equipment List',
        MY_TOP_PRODUCTS: 'Most Purchased Products',
        NOTIFICATIONS: 'Notifications',
        LOGOUT: 'Logout',
      },
    },
    CONTACT_PAGE: {
      TITLE: 'Contact',
      INTRO: 'Our team of specialists is always ready to assist you. Choose the right department to connect directly or send a consultation request via the form below.',
      TAB_ALL: 'All',
      SEARCH_PLACEHOLDER: 'Search by name, position, area covered, phone number...',
      RESULT_COUNT: '{{count}} staff',
      LOADING: 'Loading staff list...',
      EMPTY: 'No matching staff found.',
      PERSON_LANGUAGES: 'Languages: {{languages}}',
      BTN_COLLAPSE: 'Collapse',
      BTN_VIEW_DETAIL: 'View details',
      BTN_CONTACT_PERSON: 'Contact this person',
      DETAIL_BIO_LABEL: 'About:',
      DETAIL_DEPARTMENT_LABEL: 'Department:',
      FORM_TITLE: 'Send a consultation request',
      FORM_DESC: 'Fill in the information below and we will respond as soon as possible.',
      FORM_SUCCESS: 'Your message has been sent successfully! We will contact you soon.',
      FORM_SUBMITTING: 'Sending...',
      FORM_SUBMIT: 'Send message',
      LABEL_FULL_NAME: 'Full name',
      LABEL_EMAIL: 'Email',
      LABEL_PHONE: 'Phone number',
      LABEL_COMPANY: 'Company',
      LABEL_DEPARTMENT: 'Receiving department',
      LABEL_PERSON: 'Receiving person',
      LABEL_SUBJECT: 'Subject',
      LABEL_MESSAGE: 'Message',
      PLACEHOLDER_SELECT_DEPARTMENT: '-- Select department --',
      PLACEHOLDER_SELECT_PERSON: '-- Select person --',
      LOADING_PERSONS: 'Loading staff list...',
      ERR_FULL_NAME: 'Please enter your full name.',
      ERR_EMAIL: 'Invalid email.',
      ERR_SUBJECT: 'Please enter a subject.',
      ERR_MESSAGE: 'Please enter your message.',
      ERR_PHONE_REQUIRED: 'Please enter your phone number.',
      ERR_PHONE_PATTERN: 'Phone number may only contain digits (0-9).',
      ERR_PHONE_MAXLENGTH: 'Phone number may not exceed 15 digits.',
      ERR_PHONE_INVALID: 'Invalid phone number.',
      ERR_SUBMIT: 'Failed to send your message. Please try again.',
      ERR_SUBMIT_GENERIC: 'An error occurred while sending your message. Please try again later.'
    },
    MY_INQUIRIES: {
      TITLE: 'My Inquiries',
      SEARCH_PLACEHOLDER: 'Search by subject, message, department, person...',
      LOADING: 'Loading inquiries...',
      LOADING_DETAIL: 'Loading details...',
      EMPTY: 'You have not submitted any inquiries yet.',
      COL_SUBJECT: 'Subject',
      COL_DEPARTMENT: 'Department',
      COL_STATUS: 'Status',
      COL_CREATED: 'Submitted at',
      STATUS_ALL: 'All statuses',
      STATUS_NEW: 'New',
      STATUS_IN_PROGRESS: 'In progress',
      STATUS_RESOLVED: 'Resolved',
      STATUS_CLOSED: 'Closed',
      DETAIL_SUBJECT: 'Subject',
      DETAIL_DEPARTMENT: 'Receiving department',
      DETAIL_PERSON: 'Receiving person',
      DETAIL_CREATED: 'Submitted at',
      DETAIL_RESOLVED_AT: 'Resolved at',
      DETAIL_RESOLVED_BY: 'Resolved by',
      DETAIL_MESSAGE: 'Your message',
      DETAIL_ADMIN_NOTES: 'Reply from Sapatco',
      PAGE_INFO: 'Showing {{from}}–{{to}} of {{total}}',
      ERR_DETAIL: 'Failed to load inquiry details. Please try again.'
    },
    NOTIFICATIONS_PAGE: {
      TITLE: 'Notifications',
      TAB_UNREAD: 'Unread',
      TAB_ALL: 'All',
      MARK_ALL_READ: 'Mark all as read',
      LOAD_MORE: 'Load more',
      LOADING: 'Loading notifications...',
      EMPTY: 'No notifications'
    },
    EQUIPMENT: {
      PAGE_TITLE: 'My Equipment',
      ADD_EQUIPMENT: 'Add equipment',
      IMPORT_EXPORT: 'Import/Export',
      EMPTY_TITLE: 'Add your first piece of equipment',
      EMPTY_DESC: 'Add equipment to start browsing machine-specific information and keep track of related orders & research.',
      INFO_ORDER_TITLE: 'Start ordering parts from your stored machines to receive part suggestions.',
      INFO_ORDER_DESC: 'By ordering parts via "My equipment", we can start building insights for your fleet and speed up your ordering process.',
      CONFIGURE_MACHINE: 'Configure your machine',
      OWN_REFERENCE: 'Own reference',
      LOCATION: 'Location',
      PRODUCTION_MONTH: 'Production month',
      PRODUCTION_YEAR: 'Production year',
      SELECT_MACHINE: 'Select machine',
      FILTER_MAKES_MODELS: 'Filter on all makes and models',
      MAKE: 'Make',
      MODEL: 'Model',
      TYPE_OR_SELECT: 'Type or select',
      SELECT_MAKE_FIRST: 'Select make first',
      SERIAL_PREFIX: 'Serial prefix',
      SERIAL_NUMBER: 'Serial number',
      FIELD_REQUIRED: 'This field is required',
      REFINE_MODEL: 'Refine model',
      SELECT_MODEL_MACHINE: 'Select the model of your machine',
      REFINE_SPECS: 'Refine specifications (optional)',
      SELECT_SPECS_MACHINE: 'Select the specifications of your machine.',
      MAST: 'Lift frame',
      CANCEL: 'Cancel',
      PRODUCTION: 'Production',
      ADDED: 'Added',
      VIEW_DETAIL: 'View detail',
      RECENT_SEARCHES: 'Recent make/model searches',
      PURCHASE_HISTORY: 'Purchase history',
      PART_PACKAGES: 'Part packages',
      NO_PURCHASE_HISTORY: 'No purchase history for this equipment.',
      NO_PACKAGES: 'No part packages available for this equipment.',
      REORDER: 'Reorder',
      ADD_PACKAGE_TO_CART: 'Add package to cart',
      LICENSE_PLATE: 'License plate',
      HOUR_METER: 'Hour meter (hrs)',
      NOTES: 'Notes',
      EDIT_EQUIPMENT: 'Edit equipment',
      UPDATE_EQUIPMENT: 'Update equipment',
      HOURS: 'hours',
      ADD_PHOTO: 'Add equipment photo',
      CHANGE_PHOTO: 'Change photo',
      COMPATIBLE_PARTS: 'Compatible parts',
      NO_COMPATIBLE_PARTS: 'No compatible parts found for this equipment.',
      TIRE_INFO: 'Tire Information',
      STEERING_TIRE_SIZE: 'Steering tire size',
      STEERING_TIRE_TYPE: 'Steering tire type',
      STEERING_TIRE_LABEL: 'Steering tire',
      LOAD_TIRE_SIZE: 'Load tire size',
      LOAD_TIRE_TYPE: 'Load tire type',
      LOAD_TIRE_LABEL: 'Load tire',
      SPARE_TIRE_SIZE: 'Spare tire size',
      SPARE_TIRE_TYPE: 'Spare tire type',
      SPARE_TIRE_LABEL: 'Spare tire'
    },
    DOWNLOAD: {
      PAGE_TITLE: 'Download documents, catalogs and brochures',
      LOADING: 'Loading data...',
      ERROR_TITLE: 'An error occurred',
      ERROR_RETRY: 'Retry',
      FILE: 'document',
      EMPTY_CATEGORY: 'No documents in this category.',
      EMPTY_TITLE: 'No categories',
      EMPTY_DESC: 'There are currently no document categories available for download.',
      NO_PREVIEW: 'Cannot preview this file',
      NO_PREVIEW_HINT: 'Please download to view content',
      NO_PREVIEW_FORMAT: 'Files with the {{ext}} format cannot be previewed in the browser.',
      NO_PREVIEW_ACTION: 'Please download the file to open it with a suitable application.',
      PAID_OVERLAY: 'Paid document',
      PAID_BADGE: 'Paid',
      FREE_BADGE: 'Free',
      PAID_BLOCK_TITLE: 'Paid document',
      PAID_BLOCK_DESC: 'Please contact us to request access to this document.',
      PAID_BUTTON_LABEL: 'Paid document',
      // DOWNLOAD_NOW: 'Download now',
      DOWNLOAD_BTN: 'Download',
      LOADING_PREVIEW: 'Loading preview...',
      PREVIEW_10_PAGES: 'Preview – first 10 pages',
      PAID_PAYMENT_DESC: 'Pay to download the full document.',
      UNLOCKED_TITLE: 'Document unlocked',
      UNLOCKED_DESC: 'You can download the full document.',
      PAY_WITH_MOMO: 'Pay with Momo',
      PROCESSING_PAYMENT: 'Processing...',
      PENDING_PAYMENT: 'Please scan the QR code in the Momo app to complete payment.',
      CONFIRM_PAID_DOWNLOAD: 'I have paid – Download now',
      CONFIRMING_PAYMENT: 'Confirming...',
      RETRY_PAYMENT: 'Pay again',
      IPN_PROCESSING: 'Confirming payment, please wait...',
      IPN_SUCCESS: 'Payment successful! Your file is downloading.',
      IPN_REDOWNLOAD: 'Download again',
      SEARCH_PLACEHOLDER: 'Search documents...',
      ALL_CATEGORIES: 'All categories',
      SEARCH_RESULTS: 'Search results ({{total}})',
      SEARCHING: 'Searching...',
      NO_SEARCH_RESULTS: 'No matching documents found.'
    },
    ABOUT_US: {
      PAGE_TITLE: 'About Us',
      ADDRESS_LABEL: 'Address',
      COMPANY_NAME: 'BIM BIM JOINT STOCK COMPANY',
      COMPANY_SHORT_NAME: 'BIM BIM JSC',
      COMPANY_TAX_CODE: '0318955259',
      COMPANY_ADDRESS: '119 B Street, Hiep Binh Chanh Ward, Thu Duc City, Ho Chi Minh City, Vietnam',
      COMPANY_HOTLINE: '+84 934 920 935',
      COMPANY_EMAIL: 'marketing@bimbimgroup.com',
      VISION: 'Vision',
      VISION_CONTENT: 'To become the leading trusted partner in the industrial parts and equipment supply industry.',
      MISSION: 'Mission',
      MISSION_CONTENT: 'Provide high quality products at competitive prices with professional and fast service.',
      WHY_CHOOSE_US: 'Why Choose Us',
      CONTACT_TITLE: 'Contact Us',
      CONTACT_DESC: 'For consultation and best quote',
      FEATURES: {
        QUALITY: {
          TITLE: 'Quality Guaranteed',
          DESC: 'Genuine products with full warranty',
        },
        SHIPPING: {
          TITLE: 'Nationwide Delivery',
          DESC: 'Fast and safe transportation',
        },
        SUPPORT: {
          TITLE: '24/7 Support',
          DESC: 'Professional consulting team',
        },
        CERTIFICATE: {
          TITLE: 'Full License',
          DESC: 'Reputable and transparent business',
        }
      }
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        AGREEMENT: 'By clicking Sign Up you agree to our',
        AGREEMENT_LINK_TEXT: 'terms of use and privacy policy of BimBim',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        EMAIL_OR_PHONE: 'Email / Phone',
        COMPANY_NAME: 'Company Name',
        PHONE: 'Phone number',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
        PLACEHOLDER: {
          EMAIL_OR_PHONE: 'Enter email or phone',
          FULLNAME: 'Enter full name',
          PHONE: 'Enter phone number',
          COMPANY_NAME: 'Enter company name',
          EMAIL: 'Enter your email',
          PASSWORD: 'Enter password',
        },
      },
      ACCOUNT_TYPE: {
        LABEL: 'Account type',
        PERSONAL: 'Personal',
        COMPANY: 'Company',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        FULLNAME_ALPHA: 'Only letters are allowed',
        PHONE_INVALID: 'Invalid phone number format',
        PASSWORD_MIN_LENGTH: 'Password must be at least 3 characters',
      },
    },
    ECOMMERCE: {
      COMMON: {
        BANNER_SLOGAN:
          'At Bimparts.vn, we refuse to deal with fake, substandard, or unverified parts',
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
        SEARCH_BY_SKU: 'Search name, Parts No., SKU...',
        SEARCH_FOR_DOCUMENTS: 'Search for documents',
        RESET: 'Reset',
        SEARCH_BRAND: 'Search brand',
        SEARCH_MANUFACTURER: 'Search manufacturer',
        FOUND_RESULTS: 'Found {{total}} products',
      },
      DOCUMENT: {
        TITLE: 'Search by documents',
        PLACEHOLDER: 'Enter search...',
        NO_DOCUMENTS: 'No documents found',
      },
      PRODUCT: {
        SAVE: 'Save',
        SELECT_TYPE: 'Select type',
        QUANTITY: 'Quantity',
        ADD_TO_CART_SUCCESS: 'Added to cart successfully',
        PRODUCT_ADDED: 'Product added successfully',
        CATEGORIES: 'PRODUCT CATEGORIES',
        BEST_SELLING: 'Best Selling',
        SPECIAL_DISCOUNTS: 'Special Discounts',
        NEW_ARRIVALS: 'New Arrivals',
        VIEW_MORE: 'View more',
        PRODUCT: 'Product',
        PRODUCTS: 'Products',
        NO_PRODUCTS: 'No products found',
        ADD_TO_CART: 'Add to cart',
        REMAINING: 'Remaining',
        SKU_LABEL: 'SKU',
        ORDER_NOW: 'Order now',
        REQUEST_QUOTE: 'Request quote',
        VIEW_PRICE: 'See price',
        CONTACT: 'Contact',
        AVAILABLE: 'Available',
        OUT_OF_STOCK: 'Out of stock',
        NOT_UPDATED: 'Not updated',
        REQUIRED_LOGIN: 'Log in for pricing',
        BRAND_USED: 'Brand used:',
        MANUFACTURER: 'Manufacturer',
        BRAND: 'Brand',
        SOLD: 'Sold:',
        VIEW_DETAIL: 'View details',
        ZOOM_HINT: 'Hover image to zoom in',
        FROM_BRAND: 'From brand:',
        QUANTITY_LABEL: 'Quantity:',
        REMAINING_WITH_COUNT: 'Remaining {{count}} products',
        PART_CODE: 'Part code',
        SHIP: 'Shipping fee',
        WARRANTY: 'Warranty',
        WEIGHT: 'Weight',
        DIMENSIONS: 'Dimensions (LxWxH)',
      },
      PRODUCT_INFORMATION: {
        TAB_DETAILS: 'Overview',
        TAB_DESCRIPTION: 'Detailed description',
        TAB_POLICY: 'Sales policy',
        EMPTY_SUMMARY: 'No product details yet.',
        EMPTY_DESCRIPTION: 'No detailed description yet.',
        POLICY_VAT_EXCLUDED: 'Above price does not include VAT {{value}}%',
        POLICY_WARRANTY_PREFIX: 'Product is technically warranted under the warranty policy of',
        POLICY_MANUFACTURER: 'the manufacturer',
        POLICY_WARRANTY_SUFFIX: 'worldwide',
        POLICY_HOTLINE_PREFIX: 'For more details please call',
        TAB_SUPPLIER_QUOTES: 'Supplier Quotes',
      },
      SUPPLIER_QUOTES: {
        TITLE: 'Supplier Quotes',
        TAB_TITLE: 'Supplier Quotes',
        ADD_NEW: 'Add new quote',
        ADD_NOW: 'Add quote now',
        CREATE_TITLE: 'Add new supplier quote',
        EDIT_TITLE: 'Update supplier quote',
        PRODUCT_LABEL: 'Product',
        SUPPLIER_NAME: 'Supplier Name',
        SUPPLIER_NAME_PLACEHOLDER: 'Enter supplier name (max 200 characters)',
        SUPPLIER_NAME_REQUIRED: 'Please enter supplier name',
        SUPPLIER_NAME_MAXLENGTH: 'Supplier name cannot exceed 200 characters',
        VARIANT: 'Variant / Classification',
        VARIANT_FALLBACK: 'Variant {{index}}',
        ALL_VARIANTS: 'All classifications',
        VARIANT_COMMON: 'Applicable to all variants',
        NO_VARIANT_COMMON: 'No classification (General quote)',
        VARIANT_BADGE_COMMON: 'General',
        VARIANT_HINT: 'Select a specific variant if this quote applies only to it.',
        NO_VARIANT_HINT: 'This product has no variants, the quote will apply to the entire product.',
        LOADING_VARIANTS: 'Loading variants...',
        PRICE: 'Quote Price',
        PRICE_WITH_UNIT: 'Quote Price (VND)',
        PRICE_REQUIRED: 'Please enter quote price',
        PRICE_MIN: 'Quote price must be greater than or equal to 0',
        QUANTITY: 'Quantity',
        QUANTITY_PLACEHOLDER: 'E.g. 10',
        QUANTITY_REQUIRED: 'Please enter quantity',
        QUANTITY_MIN: 'Quantity must be greater than or equal to 0',
        QUANTITY_HINT: 'Supports whole numbers or decimals (meters, kg,...)',
        QUOTE_TIME: 'Quote Time',
        QUOTE_TIME_REQUIRED: 'Please select quote time',
        NOTE: 'Note',
        NOTE_PLACEHOLDER: 'Enter notes about shipping, VAT, expiration, contact... (max 200 characters)',
        NOTE_MAXLENGTH: 'Note must not exceed 200 characters',
        ACTIONS: 'Actions',
        ACTION_EDIT: 'Edit',
        ACTION_DELETE: 'Delete',
        EDIT_TOOLTIP: 'Edit quote',
        DELETE_TOOLTIP: 'Delete quote',
        CANCEL: 'Cancel',
        SAVE_CHANGES: 'Save changes',
        CREATE_BTN: 'Create quote',
        REFRESH_TOOLTIP: 'Refresh list',
        FOUND_COUNT: 'Found {{count}} quotes',
        SEARCH_SUPPLIER_PLACEHOLDER: 'Search by supplier name...',
        FROM_DATE: 'From date',
        FILTER_DATE_TOOLTIP: 'Filter quotes from this date onwards',
        CLEAR_DATE: 'Clear date',
        SEARCH: 'Search',
        RESET_FILTERS: 'Reset',
        RESET_TOOLTIP: 'Refresh & reset filters',
        LOADING: 'Loading supplier quotes...',
        EMPTY_TITLE: 'No supplier quotes yet',
        EMPTY_DESC_ALL: 'Click the button below to add the first supplier quote for this product.',
        EMPTY_DESC_FILTER: 'No quotes found for the selected variant.',
        DELETE_CONFIRM_TITLE: 'Confirm Delete Quote',
        DELETE_CONFIRM_DESC: 'Are you sure you want to delete the quote from supplier "{{supplier}}"?',
        DELETE_WAIT: 'Deleting quote...',
        DELETE_SUCCESS: 'Supplier quote deleted successfully',
        DELETE_ERROR: 'Failed to delete supplier quote',
        CREATE_SUCCESS: 'Supplier quote created successfully',
        CREATE_ERROR: 'Failed to create supplier quote',
        UPDATE_SUCCESS: 'Supplier quote updated successfully',
        UPDATE_ERROR: 'Failed to update supplier quote',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    PROFILE: {
      MY_INQUIRIES: 'My Inquiries',
      CHANGE_AVATAR: {
        TITLE: 'Change Avatar',
        CURRENT: 'Current Avatar',
        CHOOSE_NEW: 'Choose new image:',
        PREVIEW: 'Preview:',
        CANCEL: 'Cancel',
        SAVE: 'Save',
        TOOLTIP: 'Choose profile image',
      },
      USER_INFO: {
        TITLE: 'Account Information',
        DETAIL: {
          USER_NAME: 'Full Name',
          PHONE: 'Phone Number',
          EMAIL: 'Email',
          ROLE: 'Role',
          CUSTOMER_CODE: 'Customer Code',
          GENDER: {
            LABEL: 'Gender',
            OPTIONS: {
              MALE: 'Male',
              FEMALE: 'Female',
              OTHER: 'Other',
            },
          },
          DATE_OF_BIRTH: 'Date of Birth',
          DATE_OF_BIRTH_REQUIRED: 'Please select your date of birth',
          UPDATE: 'Update',
          CHANGE_PASSWORD: 'Change Password',
          OLD_PASSWORD: {
            LABEL: 'Old Password',
            INPUT_PLACEHOLDER: 'Enter old password',
          },
          NEW_PASSWORD: {
            LABEL: 'New Password',
            INPUT_PLACEHOLDER: 'Enter new password',
          },
          CONFIRM_NEW_PASSWORD: {
            LABEL: 'Confirm New Password',
            INPUT_PLACEHOLDER: 'Re-enter new password',
          },
          NO_CUSTOMER_CODE: 'N/A',
        },
        INPUT_PLACEHOLDER: {
          USER_NAME_INPUT_PLACEHOLDER: 'Enter full name',
          CUSTOMER_CODE_INPUT_PLACEHOLDER: 'Enter customer code',
          PHONE_INPUT_PLACEHOLDER: 'Enter your phone number',
          EMAIL_INPUT_PLACEHOLDER: 'Enter your email',
          OLD_PASSWORD_INPUT_PLACEHOLDER: 'Enter old password',
          NEW_PASSWORD_INPUT_PLACEHOLDER: 'Enter new password',
          CONFIRM_NEW_PASSWORD_INPUT_PLACEHOLDER: 'Re-enter new password',
          LOADING_ROLE: 'Loading...',
          NO_ROLE: 'No role assigned',
        },
        ERRORS: {
          ERROR_USER_NAME_REQUIRED: 'Please enter your full name.',
          ERROR_PHONE_REQUIRED: 'Please enter your phone number.',
          ERROR_EMAIL_FORMAT: 'Invalid email format.',
          ERROR_EMAIL_REQUIRED: 'Please enter your email address.',
          EMAIL_INVALID: 'Email is not valid.',
          ERROR_GENDER_REQUIRED: 'Please select your gender.',
          DATE_OF_BIRTH_REQUIRED: 'Please select your date of birth.',
          ERROR_DATE_OF_BIRTH_REQUIRED: 'Please select your date of birth.',
          ERROR_OLD_PASSWORD: 'Please enter your current password.',
          ERROR_NEW_PASSWORD: 'Please enter a new password.',
          ERROR_CONFIRM_NEW_PASSWORD: 'Please confirm your new password.',
          ERROR_PASSWORD_MATCH: 'Passwords do not match.',
        },
      },
      MY_DEBT: {
        TITLE: 'Debt Tracking',
        DEBT_DAYS: 'Debt limit:',
        DATE_FILTER: 'Select time period',
        DATE_ALL: 'All',
        DATE_TODAY: 'Today',
        DATE_LAST_7_DAYS: 'Last 7 days',
        DATE_LAST_30_DAYS: 'Last 30 days',
        DATE_THIS_WEEK: 'This week',
        DATE_THIS_MONTH: 'This month',
        DATE_THIS_QUARTER: 'This quarter',
        DATE_THIS_YEAR: 'This year',
        DATE_CUSTOM: 'Custom',
        FROM_DATE: 'From date',
        TO_DATE: 'To date',
        SEARCH: 'Search',
        SEARCH_PLACEHOLDER: 'Search customer name, order code...',
        ORDER_CODE: 'Order Code',
        CREATED_DATE: 'Created Date',
        TOTAL_AMOUNT: 'Total Amount',
        PAID_AMOUNT: 'Paid Amount',
        REMAINING_AMOUNT: 'Remaining',
        HISTORY: 'History',
        ACTIONS: 'Actions',
        VIEW: 'View',
        PAYMENT_HISTORY_FOR_ORDER: 'Payment history for order',
        PERIOD: 'Period',
        DATE: 'Date',
        METHOD: 'Method',
        BANK: 'Bank',
        AMOUNT: 'Amount',
        NOTE: 'Note',
        NO_PAYMENT: 'No payments yet.',
        LOADING: 'Loading...',
        NO_DEBT_ORDER: 'No unpaid orders.',
        LOADING_DATA: 'Loading data...',
        DAYS: 'days',
        BUTTON_DETAIL: 'Order detail',
        BUTTON_CLOSE: 'Close',
        VIEW_DEBT_CONFIG: 'Custom term',
        DEBT_CONFIG_TITLE: 'Custom debt term for order',
        DUE_DATE: 'Due date',
        REASON: 'Reason',
        NO_CUSTOM_DEBT_CONFIG: "This order is using the system's default debt term.",
        LOADING_DEBT_CONFIG: 'Loading debt config...',
        LOAD_DEBT_CONFIG_ERROR: 'Failed to load debt config. Please try again later.'
      },
      COMPANY_INFO: {
        TITLE: 'Company Information',
        DETAIL: {
          COMPANY_NAME: 'Company Name',
          REPRESENTATIVE: 'Representative',
          TAX_CODE: 'Tax Code',
          ADDRESS: 'Address',
          ATTACHED_DOCUMENTS: 'Attached Documents',
          UPDATE: 'Update',
        },
        INPUT_PLACEHOLDER: {
          COMPANY_NAME_INPUT_PLACEHOLDER: 'Enter company name',
          REPRESENTATIVE_INPUT_PLACEHOLDER: "Enter representative's name",
          TAX_CODE_INPUT_PLACEHOLDER: 'Enter tax code',
          ADDRESS_INPUT_PLACEHOLDER: 'Enter company address',
          ATTACHED_DOCUMENTS_INPUT_PLACEHOLDER: 'Upload attached documents (if any)',
        },
        ERRORS: {
          ERROR_COMPANY_NAME_REQUIRED: 'Please enter the company name.',
          ERROR_REPRESENTATIVE_REQUIRED: "Please enter the representative's name.",
          ERROR_TAX_CODE_REQUIRED: 'Please enter the tax code.',
          ERROR_TAX_CODE_INVALID: 'Invalid tax code.',
          ERROR_ADDRESS_REQUIRED: 'Please enter the address.',
          ERROR_ATTACHED_DOCUMENTS_REQUIRED: 'Please upload the attached documents.',
        },
        MESSAGES: {
          UPDATE_SUCCESS: 'Company information updated successfully.',
          UPDATE_ERROR: 'An error occurred while processing the file. Please try again.',
        },
      },

      ORDER_INFO: {
        TITLE: 'My Orders',
        TABLE: {
          ORDER_CODE: 'Order Code',
          PURCHASE_DATE: 'Purchase Date',
          PRODUCT: 'Product',
          TOTAL: 'Total Amount',
          STATUS: 'Status',
          INVOICE: 'Invoice',
        },
        DOWNLOAD: {
          PDF: 'Download PDF',
          EXCEL: 'Download Excel',
          RECEIPT: 'Download Handover Document',
          QUOTATION: 'Download Quotation',
          CONTRACT_WORD: 'Download Contract'
        },
        PAGINATION: {
          ITEMS_PER_PAGE: 'Items per page',
          OF: 'of total',
        },
        INPUT_PLACEHOLDER: {
          SEARCH_PLACEHOLDER: 'Enter search keyword',
          STATUS_PLACEHOLDER: 'Order placed, Order confirmed, ...',
          DATE_PLACEHOLDER: 'Select search date',
        },
        EMPTY: 'No orders found.',
      },

      ADDRESS_BOOK: {
        TITLE: 'Address Book',
        DETAIL: {
          FULLNAME: 'Full Name',
          PHONE: 'Mobile Phone',
          PROVINCE: 'Province/City',
          DISTRICT: 'District',
          WARD: 'Ward/Commune',
          ADDRESS_NUMBER: 'Address Number',
          ADDRESS: 'Address',
          ADDRESS_TYPE: 'Address Type',
          DEFAULT_ADDRESS: 'Set this address as default',
          PRIVATE_OR_APARTMENT: 'Private House / Apartment',
          COMPANY_OR_OFFICE: 'Company / Office',
          ADD_NEW: 'Add New Address',
          ADD_NEW_ADMINISTRATIVE: 'New Administrative Address',
          ADDRESS_NOTE: 'Former Administrative Address',
          ADDRESS_MAX_LENGTH: 'Maximum 100 characters',
          EDIT_ADDRESS: 'Edit Address',
          DELETE: 'Delete',
          SAVE: 'Save',
          CANCEL: 'Cancel',
          UPDATE: 'Update',
        },
        INPUT_PLACEHOLDER: {
          FULLNAME: 'Enter full name',
          PHONE: 'Enter mobile phone number',
          PROVINCE: 'Select province/city',
          DISTRICT: 'Enter district',
          WARD: 'Enter ward/commune',
          ADDRESS_NUMBER: 'Enter house number / specific address',
          ADDRESS: 'Example: 12/3 Bach Dang',
        },
      },
    },
    BRANDS: {
      TITLE: 'GENUINE SPARE PARTS AND OEM PARTS FOR VARIOUS BRANDS',
    },
    VIDEO: {
      TITLE: 'SEARCH FOR RELATED SPARE PARTS',
      SUB_TITLE: 'Most accurate - Cheapest - Closest to you',
    },
    FOOTER: {
      COMPANY_INFO: {
        TITLE: 'BIM BIM JOINT STOCK COMPANY',
        NAME_EN: 'International Name',
        NAME_SHORT: 'Abbreviation',
        TAX_CODE: 'Tax Code',
        ADDRESS: 'Address',
        HOTLINE: 'Hotline',
        EMAIL: 'Email',
        INTERNATIONAL: 'International Name',
        ABBREVIATED_NAME: 'Abbreviated Name',
      },
      CONTACT: 'Contact',
      PRODUCT_SERVICE: {
        TITLE: 'Products & Services',
        SPARE_PARTS: 'Find parts by document',
        MAINTENANCE: 'Forklift maintenance services',
        USED_PARTS: 'Used parts',
        REPAIR_TITLE: 'Repair & Restoration',
        TECHNICIAN: 'Forklift technician',
        BATTERY: 'Battery restoration',
        PUMP: 'Hydraulic pump restoration',
        INJECTION: 'Fuel injector restoration',
      },
      DOWNLOAD: {
        TITLE: 'Downloads',
        CATALOGUE: 'Catalogues',
        BROCHURE: 'Brochures',
        MAINT_DOC: 'Maintenance documents',
        VIDEO: 'Video',
      },
      LANGUAGE: {
        TITLE: 'Language Options',
        VI: 'Vietnamese',
        EN: 'English',
        ZH: 'Chinese',
      },
      PARTNERSHIP: {
        TITLE: 'Partnership & Links',
        SUPPLIERS: 'Suppliers',
        SELL_WITH_US: 'Sell with BimBim',
        CERTIFIED_BY: 'CERTIFIED BY',
        CERTIFICATION_LOGO: 'Certification Logo',
      },
      INFORMATION: {
        TITLE: 'Information',
      },
    },
    FOOTER_BOTTOM: {
      FREE_APP: 'Free App:',
      CONNECT_WITH_US: 'Connect with us',
      COPYRIGHT: '2025 © Copyright BIM BIM JOINT STOCK COMPANY',
      COMPANY_COPYRIGHT_SUFFIX: 'Copyright BIM BIM JOINT STOCK COMPANY',
      LICENSE:
        'Business Registration No. 0318955259 issued by Ho Chi Minh City Department of Finance on 16/05/2025',
      PRIVACY_POLICY: 'Privacy Policy',
      TERMS_CONDITIONS: 'Terms & Conditions',
      APP_STORE: 'Download on the App Store',
      GOOGLE_PLAY: 'Get it on Google Play',
      LANGUAGE_DISCLAIMER:
        'Bim Bim is not responsible for any discrepancies between the English version and other language versions. In the event of any conflict, the English version shall prevail. By using our website, you acknowledge and agree to our Terms and Conditions.',
    },
    FOOTER_SLOGAN: '"Faster, Better, Cheaper"',
    SIDE_WIDGETS: {
      CONTACT_US: 'Contact Us',
      CHAT_NOW: 'Chat now!',
      CONSULTATION: 'Consultation',
    },
    ASK_FORM: {
      TITLE: 'You need to ask more?',
      SALES_TEXT: 'Our Sales Executive will respond to your email immediately',
      QUESTION_PLACEHOLDER: '*Question:',
      ADD_FILE: 'Add pics, file...',
      NAME_PLACEHOLDER: '*Your name:',
      EMAIL_PLACEHOLDER: '*Your Email:',
      PHONE_PLACEHOLDER: '*Your Phone:',
      SEND_BTN: 'Send Question',
      NOTIFICATIONS: {
        WARNING_TITLE: 'Notification',
        REQUIRED_QUESTION: 'Please enter your question',
        SUCCESS_TITLE: 'Success',
        SUCCESS_MSG: 'Question sent successfully!',
        ERROR_TITLE: 'Error',
        ERROR_MSG: 'An error occurred',
        SYSTEM_ERROR: 'System error, please try again later.',
      },
    },
  },
};
